/** @file segmentDistance: the distance in pixels from a screen point to a screen segment. */

/** Distance from `(x, y)` to the segment `a`-`b` (to `a` when the segment has no length). */
export function segmentDistance(x: number, y: number, a: readonly [number, number], b: readonly [number, number]): number {
  const dx = b[0] - a[0];
  const dy = b[1] - a[1];
  const len2 = dx * dx + dy * dy;
  const t = len2 === 0 ? 0 : Math.max(0, Math.min(1, ((x - a[0]) * dx + (y - a[1]) * dy) / len2));
  return Math.hypot(x - (a[0] + t * dx), y - (a[1] + t * dy));
}
